import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
/* Environment */
import { environment } from '../../../environments/environment';

@Injectable()
export class SettingsProvider {

  private config: any;
  private error: any;

  constructor(private http: HttpClient) {
  }

  public loadConfig(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.config = environment;
      resolve(this.config);
      // this.http.get('./assets/config/client-config.json').subscribe(
      //     data => {
      //         console.log(data);
      //         this.config = data;
      //         console.log('Fetched Conversions');                
      //         resolve(this.config);
      //     },
      //     (err: HttpErrorResponse) => {
      //         this.error = err; // error path
      //         console.log('Error Fetching config');
      //         console.log(this.error);
      //         reject(this.error);

      //     }
      // );
    });
  }

  public get configuration(): any {
    return this.config;
  }

}
